<template>
    <div class="mt-5">
        <span class="nav locale-font">
            <span
                class="pointer"
                @click="goToEmployee()">
                {{ this.$vuetify.lang.t('$vuetify.employeeImport.employeeManagement') }}
            </span>
            / {{ this.$vuetify.lang.t('$vuetify.employeeImport.importEmployeeList') }}
        </span>

        <div class="header mt-2 locale-font">
            {{ this.$vuetify.lang.t('$vuetify.employeeImport.importEmployeeList') }}
        </div>

        <v-card class="content-container">
            <div class="import-container">
                <v-container>
                    <v-radio-group v-model="selectedType" row>
                        <v-radio
                            v-for="(employeeType, employeeTypeIndex) in employeeTypes"
                            :key="employeeTypeIndex"
                            :label="employeeType.text"
                            :value="employeeType.value"
                            class="locale-font"
                        ></v-radio>
                    </v-radio-group>

                    <div class="mt-3">
                        <employee-import-list
                            v-show="showImportEmployeeList"
                            :branchId="branchId"/>
                        <employee-import-image
                            v-show="showImportEmployeeImage"
                            :branchId="branchId"/>
                        <employee-import-annual-workinghour
                            v-show="showImportAnnualWorkinghour"
                            :branchId="branchId"/>
                    </div>
                </v-container>
            </div>
        </v-card>
    </div>
</template>

<script>
import EmployeeImportList from '@/components/employee/EmployeeImportList'
import EmployeeImportImage from '@/components/employee/EmployeeImportImage'
import EmployeeImportAnnualWorkinghour from '@/components/employee/EmployeeImportAnnualWorkinghour'

const EMPLOYEE_LIST_TYPE = 'List'
const EMPLOYEE_IMAGE_TYPE = 'Image'
const EMPLOYEE_ANNUAL_TYPE = 'Annual'
export default {
    name: 'EmployeeImport',

    components: {
        EmployeeImportList,
        EmployeeImportImage,
        EmployeeImportAnnualWorkinghour
    },

    computed: {
        employeeTypes () {
            return [
                {
                    text: this.$vuetify.lang.t('$vuetify.employeeImport.employeeList'),
                    value: EMPLOYEE_LIST_TYPE
                }, {
                    text: this.$vuetify.lang.t('$vuetify.employeeImport.employeeImage'),
                    value: EMPLOYEE_IMAGE_TYPE
                }
            ]
        },
        showImportEmployeeList () {
            return this.selectedType === EMPLOYEE_LIST_TYPE
        },

        showImportEmployeeImage () {
            return this.selectedType === EMPLOYEE_IMAGE_TYPE
        },

        showImportAnnualWorkinghour () {
            return this.selectedType === EMPLOYEE_ANNUAL_TYPE
        }
    },

    data () {
        return {
            selectedType: EMPLOYEE_LIST_TYPE,
            branchId: null
        }
    },

    methods: {
        goToEmployee () {
            this.$router.push({ name: 'Employees' }, () => {})
        },

        async getBranch () {
            this.branchId = parseInt(localStorage.getItem('currentBranchId'))
        }
    },

    async mounted () {
        await this.getBranch()
    }
}
</script>

<style lang="scss" scoped>
.nav {
    color: #6c6c6c;
}
.pointer {
    cursor: pointer;
}
.header {
    margin-bottom: 2rem;
    font-size: 28px;
    font-weight: bold;
}
.import-container {
    padding: 1rem;
}
</style>
